import { toast } from 'material-react-toastify';

import { billingApi, hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { tariffKeys } from '@/lib/query/keys/tariff';
import { PaymentProvider } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

import { normalizeTariffs } from '../utils/normilize-tariffs';

export enum TariffType {
  Subscription = 'subscription',
  OneTimePurchase = 'oneTimePurchase',
}

const defaultTablePageSize = 5000;

export const useTariffs = (tariffType: TariffType, search?: string) => {
  const trimmedSearch = search?.trim() ? search.trim() : undefined;

  return useQuery({
    queryKey: tariffKeys.typeWithSearch(tariffType, trimmedSearch),
    queryFn: async () => {
      const token = await getAuthToken();
      let response;
      try {
        switch (tariffType) {
          case TariffType.Subscription:
            response = await hubApi.getSubscriptionsTariffsWithLTVHub(
              trimmedSearch,
              undefined,
              defaultTablePageSize,
              withAuthHeader(token),
            );
            break;
          case TariffType.OneTimePurchase:
            response = await billingApi.getOneTimePurchasesTariffsV2(
              [PaymentProvider.Solid],
              undefined,
              trimmedSearch,
              undefined,
              defaultTablePageSize,
              withAuthHeader(token),
            );
            break;
        }

        return response.data.tariffs.map(normalizeTariffs);
      } catch (error) {
        Sentry.captureException(`Failed to fetch tariffs: ${error.message}`);
        toast.error(`Failed to fetch tariffs: ${error.message}`);
        return [];
      }
    },
  });
};
